"use client";

import Link from "next/link";
import React from "react";

const NotFoundComponent = () => {
  return (
    <section className="page-section">
      <div className="page-decoration-1"></div>
      <div className="page-decoration-2"></div>
      <div className="page-decoration-3"></div>
      <div className="full-width-screen">
        <div className="container-fluid">
          <div className="content-detail">
            <h1 className="global-title">
              <span>4</span>
              <span>0</span>
              <span>4</span>
            </h1>
            <div className="page-desc">
              <h4 className="sub-title">Oops!</h4>
              <p className="detail-text">
                We're sorry,
                <br /> The page you were looking for doesn't exist anymore.
              </p>
              <div className="back-btn">
                <Link href="/" className="btn">
                  Back to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFoundComponent;
